import requestUtil from "../../../helpers/requestUtil";
import { setLoading } from "../Loader/slice";
import * as Toasts from '../../common/Toastify';

export const mapDepartmentsToCandidate =({baseURL,mappedParams}) => {
    return  async (dispatch) => {
        dispatch(setLoading(true));
        try {
          const response = await requestUtil(`${baseURL}/Departments/map-department-candidate`, "POST", { ...mappedParams });
          Toasts.success(response?.message)
          return response?.result ? true : false;
        } catch (error) {
          Toasts.error(error?.message)
          return false;
        } finally {
          dispatch(setLoading(false));
        }
      };
}
